/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

import {
     DatabaseAgileFieldFromJSONTyped,
     DatabaseBasicFieldFromJSONTyped,
     DatabaseCalcFieldFromJSONTyped,
     DatabaseCategoryFieldFromJSONTyped,
     DatabaseChecklistFieldFromJSONTyped,
     DatabaseCombinedTextFieldFromJSONTyped,
     DatabaseCreatedByFieldFromJSONTyped,
     DatabaseCreatedDateFieldFromJSONTyped,
     DatabaseCurrencyFieldFromJSONTyped,
     DatabaseDateFieldFromJSONTyped,
     DatabaseEmailFieldFromJSONTyped,
     DatabaseEntryLinkFieldFromJSONTyped,
     DatabaseFileFieldFromJSONTyped,
     DatabaseImageFieldFromJSONTyped,
     DatabaseImageSeriesFieldFromJSONTyped,
     DatabaseLinkFieldFromJSONTyped,
     DatabaseModifiedByFieldFromJSONTyped,
     DatabaseModifiedDateFieldFromJSONTyped,
     DatabaseMultiFileFieldFromJSONTyped,
     DatabaseNumberFieldFromJSONTyped,
     DatabaseOwnerFieldFromJSONTyped,
     DatabaseParentEntryFieldFromJSONTyped,
     DatabasePasswordFieldFromJSONTyped,
     DatabasePercentageFieldFromJSONTyped,
     DatabasePeriodFieldFromJSONTyped,
     DatabaseRatingFieldFromJSONTyped,
     DatabaseSequenceFieldFromJSONTyped,
     DatabaseEntryStatisticsFieldFromJSONTyped,
     DatabaseTelnumberFieldFromJSONTyped,
     DatabaseTextFieldFromJSONTyped,
     DatabaseVideoFieldFromJSONTyped,
     DatabaseYesNoFieldFromJSONTyped
} from './';

/**
 * MINDESTEINSTELLUNGEN (Vorgabe des Betreibers 02.10.2026). Mehrere Feldarten haben einen Schalter, ohne den sie nichts tun: Gespeichert wird trotzdem, die Maske zeigt das Feld, und erst beim Benutzen faellt auf, dass die Auswahl leer bleibt oder der Hochladeknopf fehlt.
 * DIESE REGELN GELTEN AUF BEIDEN SEITEN und halten das Speichern auf — im Feld-Editor (`feldKonfigPruefung.ts`) wie beim Schreiben ueber die Schnittstelle (`FeldKonfigPruefung.java`). Sie stehen hier, weil diese Datei das einzige ist, was beide Repos teilen; je ein Waechter haelt seine Seite gegen diese Liste.
 * kategorie-ohne-darstellung  CATEGORY_FIELD ohne `type` hat im Datensatz
 *                             kein Bedienelement.
 * bild-ohne-art               IMAGE_FIELD ohne `type` laesst nichts
 *                             hochladen.
 * 
 * NUR TYP-EIGENE REGELN. Was eine ROLLE einer Vorlage von ihrem Feld erwartet (etwa: der Volltext der Bibliothek muss formatierbar sein), steht NICHT hier — Vorlagen und ihre Rollen leben im Frontend, und eine zweite Fassung im Backend waere bei jeder neuen Vorlage die vergessene. Dafuer gibt es den Feld-Editor und `werkzeuge/pruefe-felder.mjs`.
 * GEPRUEFT WIRD BEIM AENDERN, NICHT BEIM ANLEGEN: Die Oberflaeche legt ein Feld an und oeffnet dann erst den Editor, und das Erzeugen einer Datenbank aus einer Vorlage geht andere Wege — pruefte das Anlegen, liesse sich aus einer alten Vorlage mit einem unvollstaendigen Feld keine Datenbank mehr erzeugen.
 * @export
 * @interface DatabaseField
 */
export interface DatabaseField {
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    fieldType: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    readonly id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    displayInPreview?: boolean;
    /**
     * If true, this field can be edited directly in the overview
     * (list/grid/gallery) without opening the detail view. Honored by
     * CATEGORY_FIELD and YES_NO_FIELD.
     * @type {boolean}
     * @memberof DatabaseField
     */
    inlineEditable?: boolean;
    /**
     * 
     * @type {DatabaseFieldPreviewOptions}
     * @memberof DatabaseField
     */
    displayPreviewOptions?: DatabaseFieldPreviewOptions;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    titlePhrase?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showTitleAsPhrase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    hideTitle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    required?: boolean;
    /**
     * Darf ein OEFFENTLICHES Formular (POST /public/form/{dbId}) dieses
     * Feld befuellen? Standard: NEIN. Bewusst eine Freigabe je Feld statt
     * einer im Code versteckten Regel — so ist an der Oberflaeche
     * sichtbar, was eine fremde Website schreiben darf. Nur Eingabe-
     * Feldtypen sind ueberhaupt freigebbar (berechnete und
     * system-gesetzte Felder nie). Felder, die das System selbst
     * beschreibt (z.B. das Ziel-Datumsfeld einer E-Mail-Verifizierung),
     * bleiben zusaetzlich hart gesperrt.
     * @type {boolean}
     * @memberof DatabaseField
     */
    publicFormWritable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInDetails?: boolean;
    /**
     * Wird das Feld in der BEARBEITEN-Ansicht gezeigt? Gegenstueck zu
     * `showInDetails`, das nur die Anzeige steuert. Angeboten wird der
     * Schalter in der Maske nur bei BERECHNETEN Feldern: Sie lassen sich
     * ohnehin nicht eingeben, und beim Bearbeiten steht dort haeufig ein
     * veralteter oder leerer Wert, weil die Formel erst beim Speichern
     * neu rechnet. Vorgabe JA — bestehende Felder verhalten sich
     * unveraendert.
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInFilter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInSorter?: boolean;
    /**
     * Das Feld nimmt die GANZE Zeile, unabhaengig davon, wie viele Spalten die Feldgruppe hat.
     * WOFUER (Betreiber 07.10.2026): Eine Anmeldekarte, in der sich Name und Geburtsdatum eine Zeile teilen, waehrend E-Mail und die Schaetzung je eine eigene bekommen. Bis dahin galt die Spaltenzahl der Gruppe fuer ALLE ihre Felder gleich; jedes Feld bekam genau eine Zelle, und eine Zelle ueber zwei Spalten gab es nicht.
     * DER UEBLICHE AUSWEG WAR EINE EIGENE FELDGRUPPE — bei der Kontaktkarte aber unmoeglich, weil dort jede Gruppe zu einem eigenen Schritt wird.
     * FEHLT DER WERT, verhaelt sich das Feld wie bisher: eine Zelle.
     * @type {boolean}
     * @memberof DatabaseField
     */
    volleBreite?: boolean;
    /**
     * Das Feld wird groesser gezeichnet — hoeheres Eingabefeld, groessere Schrift.
     * WOFUER (Betreiber 07.10.2026): „Wie kann ich denn ein Feld z.B. Anzahl der Murmeln groesser darstellen?" In einem Gewinnspiel ist die Schaetzung die Hauptsache; sie soll sich von Name und E-Mail abheben.
     * NUR EINE STUFE, nicht mehrere: Zwei Groessen sind eine Unterscheidung, fuenf sind eine Gestaltungsaufgabe. Wer mehr braucht, soll es sagen.
     * UNABHAENGIG VON `volleBreite`: Ein hervorgehobenes Feld darf in einer geteilten Zeile stehen, und ein Feld ueber die ganze Zeile muss nicht hervorgehoben sein.
     * @type {boolean}
     * @memberof DatabaseField
     */
    hervorgehoben?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showCopyButton?: boolean;
    /**
     * Erklaerung zu DIESEM Feld, in der Maske als Info-Zeichen neben der Beschriftung sichtbar.
     * WOFUER: Manche Felder brauchen mehr als ihren Namen, um ausgefuellt zu werden -- eine Bewertung etwa ("Geschaeftswert") sagt nichts darueber, WORAN man sie festmacht. Solche Ankerfragen gehoeren an das Feld, nicht ins Handbuch: gebraucht werden sie genau in dem Moment, in dem jemand vor der Eingabe sitzt.
     * ABGRENZUNG: `titlePhrase` ERSETZT die Beschriftung, dieser Text ergaenzt sie. Die gleichnamige Angabe an einer Kategorie-Option erklaert eine einzelne Auspraegung; diese hier das ganze Feld.
     * HTML ist erlaubt (Listen, Fettdruck) -- die Quelle ist die Feldkonfiguration des Datenbank-Eigentuemers, kein Fremdinhalt.
     * @type {string}
     * @memberof DatabaseField
     */
    hinweis?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    fieldGroup?: string;
    /**
     * Loeschschutz, gesetzt vom Autor der Designvorlage (Schild-Symbol in
     * der Spalte "Aktionen"). Ist er an, kann das Feld in einer aus der
     * Vorlage erzeugten Datenbank nicht geloescht werden - im
     * Vorlagen-Editor selbst schon, sonst kaeme der Autor an sein eigenes
     * Feld nicht mehr heran. Vorgabe AUS: bestehende Vorlagen verhalten
     * sich unveraendert, der Schutz ist eine bewusste Entscheidung je Feld.
     * @type {boolean}
     * @memberof DatabaseField
     */
    deleteProtected?: boolean;
    /**
     * Primary template-role of this field (legacy single-string slot).
     * For multi-role mapping (one DB field plays N template-roles), use
     * templateFieldList in addition. The first entry of templateFieldList
     * is mirrored into templateField for backward compatibility.
     * @type {string}
     * @memberof DatabaseField
     */
    templateField?: string;
    /**
     * All template-roles played by this field. Allows the same DB field
     * to fulfill multiple roles (e.g. accountTitel AND accountBezeichnung
     * mapped to the same Bezeichnung-Feld). When empty/missing,
     * templateField is treated as the single role.
     * @type {Array<string>}
     * @memberof DatabaseField
     */
    templateFieldList?: Array<string>;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabaseField
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
}

/**
 * Check if a given object implements the DatabaseField interface.
 */
export function instanceOfDatabaseField(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fieldType" in value;

    return isInstance;
}

export function DatabaseFieldFromJSON(json: any): DatabaseField {
    return DatabaseFieldFromJSONTyped(json, false);
}

export function DatabaseFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['fieldType'] === 'AGILE_FIELD') {
            return DatabaseAgileFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'BASIC_FIELD') {
            return DatabaseBasicFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CALC_FIELD') {
            return DatabaseCalcFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CATEGORY_FIELD') {
            return DatabaseCategoryFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CHECKLIST_FIELD') {
            return DatabaseChecklistFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'COMBINED_TEXT_FIELD') {
            return DatabaseCombinedTextFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CREATED_BY_FIELD') {
            return DatabaseCreatedByFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CREATED_DATE_FIELD') {
            return DatabaseCreatedDateFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CURRENCY_FIELD') {
            return DatabaseCurrencyFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'DATE_FIELD') {
            return DatabaseDateFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'EMAIL_FIELD') {
            return DatabaseEmailFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'ENTRY_LINK_FIELD') {
            return DatabaseEntryLinkFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'FILE_FIELD') {
            return DatabaseFileFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'IMAGE_FIELD') {
            return DatabaseImageFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'IMAGE_SERIES_FIELD') {
            return DatabaseImageSeriesFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'LINK_FIELD') {
            return DatabaseLinkFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'MODIFIED_BY_FIELD') {
            return DatabaseModifiedByFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'MODIFIED_DATE_FIELD') {
            return DatabaseModifiedDateFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'MULTI_FILE_FIELD') {
            return DatabaseMultiFileFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'NUMBER_FIELD') {
            return DatabaseNumberFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'OWNER_FIELD') {
            return DatabaseOwnerFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PARENT_ENTRY_FIELD') {
            return DatabaseParentEntryFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PASSWORD_FIELD') {
            return DatabasePasswordFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PERCENTAGE_FIELD') {
            return DatabasePercentageFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PERIOD_FIELD') {
            return DatabasePeriodFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'RATING_FIELD') {
            return DatabaseRatingFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'SEQUENCE_FIELD') {
            return DatabaseSequenceFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'STATISTICS_FIELD') {
            return DatabaseEntryStatisticsFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'TELNUMBER_FIELD') {
            return DatabaseTelnumberFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'TEXT_FIELD') {
            return DatabaseTextFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'VIDEO_FIELD') {
            return DatabaseVideoFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'YES_NO_FIELD') {
            return DatabaseYesNoFieldFromJSONTyped(json, true);
        }
    }
    return {
        
        'fieldType': json['fieldType'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayInPreview': !exists(json, 'displayInPreview') ? undefined : json['displayInPreview'],
        'inlineEditable': !exists(json, 'inlineEditable') ? undefined : json['inlineEditable'],
        'displayPreviewOptions': !exists(json, 'displayPreviewOptions') ? undefined : DatabaseFieldPreviewOptionsFromJSON(json['displayPreviewOptions']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'titlePhrase': !exists(json, 'titlePhrase') ? undefined : json['titlePhrase'],
        'showTitleAsPhrase': !exists(json, 'showTitleAsPhrase') ? undefined : json['showTitleAsPhrase'],
        'hideTitle': !exists(json, 'hideTitle') ? undefined : json['hideTitle'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'required': !exists(json, 'required') ? undefined : json['required'],
        'publicFormWritable': !exists(json, 'publicFormWritable') ? undefined : json['publicFormWritable'],
        'showInDetails': !exists(json, 'showInDetails') ? undefined : json['showInDetails'],
        'showInEdit': !exists(json, 'showInEdit') ? undefined : json['showInEdit'],
        'showInFilter': !exists(json, 'showInFilter') ? undefined : json['showInFilter'],
        'showInSorter': !exists(json, 'showInSorter') ? undefined : json['showInSorter'],
        'volleBreite': !exists(json, 'volleBreite') ? undefined : json['volleBreite'],
        'hervorgehoben': !exists(json, 'hervorgehoben') ? undefined : json['hervorgehoben'],
        'showCopyButton': !exists(json, 'showCopyButton') ? undefined : json['showCopyButton'],
        'hinweis': !exists(json, 'hinweis') ? undefined : json['hinweis'],
        'fieldGroup': !exists(json, 'fieldGroup') ? undefined : json['fieldGroup'],
        'deleteProtected': !exists(json, 'deleteProtected') ? undefined : json['deleteProtected'],
        'templateField': !exists(json, 'templateField') ? undefined : json['templateField'],
        'templateFieldList': !exists(json, 'templateFieldList') ? undefined : json['templateFieldList'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
    };
}

export function DatabaseFieldToJSON(value?: DatabaseField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldType': value.fieldType,
        'displayInPreview': value.displayInPreview,
        'inlineEditable': value.inlineEditable,
        'displayPreviewOptions': DatabaseFieldPreviewOptionsToJSON(value.displayPreviewOptions),
        'name': value.name,
        'titlePhrase': value.titlePhrase,
        'showTitleAsPhrase': value.showTitleAsPhrase,
        'hideTitle': value.hideTitle,
        'active': value.active,
        'required': value.required,
        'publicFormWritable': value.publicFormWritable,
        'showInDetails': value.showInDetails,
        'showInEdit': value.showInEdit,
        'showInFilter': value.showInFilter,
        'showInSorter': value.showInSorter,
        'volleBreite': value.volleBreite,
        'hervorgehoben': value.hervorgehoben,
        'showCopyButton': value.showCopyButton,
        'hinweis': value.hinweis,
        'fieldGroup': value.fieldGroup,
        'deleteProtected': value.deleteProtected,
        'templateField': value.templateField,
        'templateFieldList': value.templateFieldList,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
    };
}

